import React, { MouseEvent } from "react";
import cn from "classnames";

import styles from "./style.module.scss";

interface IProps {
  active?: boolean;
  className?: string;
  children?: Node | null | string;
  onClick: (event: MouseEvent<HTMLElement>) => void;
  "data-qa"?: string;
}

const Chip = ({
  active = false,
  className = "",
  onClick,
  children = null,
  "data-qa": dataQa = "chip",
  ...otherProps
}: IProps) => {
  const chipClasses = cn(styles.chip, active && styles.active, className);
  return (
    // We shouldn't do this in new files, but this is too time-consuming to untangle in linting cleanup
    // eslint-disable-next-line react/jsx-props-no-spreading
    <button
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...otherProps}
      data-qa={dataQa}
      type="button"
      onClick={onClick}
      className={chipClasses}
    >
      {children}
    </button>
  );
};

export default Chip;
